<ng-container *ngIf="isBanner; else alert">
  <div class="banner-container">
    <div class="d-flex align-items-center">
      <div *ngIf="isMuteMaintenanceBannerEnabled">
        <input type="checkbox" id="banner" class="k-checkbox" (click)="muteBanner()">
        <label class="k-checkbox-label" for="banner" [title]="'dataItem.displayName'">{{ micStrings.doNotShowAgain
          }}</label>
      </div>
      <button *ngIf="closable" kendoButton class="btn-close no-text ml-auto" (click)="closeAlert()" [primary]="true"
        iconClass="fa fa-times" fillMode="flat"></button>
    </div>

    <div *ngIf="html || isHtmlText" class='operational-details' [innerHtml]="html || text"></div>
  </div>
</ng-container>

<ng-template #alert>
  <div [ngClass]="{
        'alert-content': true,
        'details-view': detailsTemplateInfo,
        'alert-success': type === 'success',
        'alert-warning': type === 'warning',
        'alert-error': type === 'error',
        'alert-info': type === 'info'
      }" class="{{customClassName}}">
    <div class="icon-operation">
      <span [ngClass]="{
        'fa': true,
        'fa-check-circle': type === 'success' || type === 'info',
        'fa-exclamation-circle': type === 'warning',
        'fa-exclamation-triangle': type === 'error'
      }"></span>
    </div>

    <div class="operation-info col-11">
      <h5>{{title}}</h5>

      <p *ngIf="!html && !isHtmlText" class="operation-description">{{text}}</p>

      <div *ngIf="html || isHtmlText" class='operational-details' [innerHtml]="html || text"></div>

      <ng-container *ngIf="detailsTemplateInfo?.detailsTemplate">
        <ng-container
          *ngTemplateOutlet="detailsTemplateInfo.detailsTemplate; context:{$implicit: detailsTemplateInfo}"></ng-container>
      </ng-container>

    </div>

    <button *ngIf="closable" kendoButton class="btn-close no-text" (click)="closeAlert()" [primary]="true"
      iconClass="fa fa-times" fillMode="flat"></button>
  </div>
</ng-template>
